import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bba2ab7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signup-intro-steps" }
const _hoisted_2 = { class: "signup-intro-steps__title" }
const _hoisted_3 = { class: "signup-intro-steps__list" }

import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupIntroSteps',
  setup(__props) {

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('signupPage.steps.title')), 1),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, _toDisplayString(_unref(t)('signupPage.steps.one')), 1),
      _createElementVNode("li", null, _toDisplayString(_unref(t)('signupPage.steps.two')), 1),
      _createElementVNode("li", null, _toDisplayString(_unref(t)('signupPage.steps.three')), 1)
    ])
  ]))
}
}

})